import React, { useState } from 'react';

import CloseIcon from 'mdi-react/CloseIcon';
import { Form, Field } from 'react-final-form';

import { useDispatch, sendFlashMessage } from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage"
import TemplateButton from '@/shared/components/TemplateButton';
import axios from 'axios';
import { connect } from 'react-redux';

const ResendActivationPopup = ({ onCancelHandler, domain }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()

  const validate = values => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    return errors;
  }

  const onSubmit = async values => {
    setLoading(true);
     
    axios.post(`activation/resend`, values)
      .then((res) => {
        if (res.status == 200) {
          dispatch(sendFlashMessage('Resend Activation link sent successfully!', 'alert-success', 'top'))
          setLoading(false)
          onCancelHandler();
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(sendFlashMessage(<ApiErrorMessage errors={err.response.data} />, 'alert-danger', 'top'))
        setLoading(false)
      })
  };

  return (
    <div className='popup login'>
      <div className='popup__content'>
        <div className="card w-100">
          <div className="card-header">Resend Activation Link</div>
          <div className="card-body mt-3">
            <Form
              onSubmit={onSubmit}
              validate={validate}
              initialValues={{}}
              render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                  <Field name="email">
                    {({ input, meta }) => (
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>
                        <input id="email" type="text" {...input} placeholder="Email" className="form-control" />
                        {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                  <TemplateButton type="submit" className="" disabled={loading} text='Resend Link' />
                </form>
              )}
            />
          </div>
        </div>
      </div>
      <div className='popup__top'>
        <CloseIcon onClick={onCancelHandler} size={30} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    domain: state.domain,
  };
};

export default connect(mapStateToProps)(ResendActivationPopup);